<script lang="ts">
	import { cn, CHIP, CHIP_IDLE, SHELL_WIDE } from '@papyria/ui';
	import AccessForm from '#lib/marketing/components/AccessForm.svelte';
	import MarketingFooter from '#lib/marketing/components/MarketingFooter.svelte';
	import MarketingHeader from '#lib/marketing/components/MarketingHeader.svelte';
	import PitchPoints from '#lib/marketing/components/PitchPoints.svelte';
	import * as m from '#lib/paraglide/messages.js';
	import type { PageData } from './$types';

	const SITE_NAME = 'Papyria';

	let { data }: { data: PageData } = $props();
</script>

<svelte:head>
	<title>{SITE_NAME}</title>
	<meta name="description" content={m.landing_intro()} />
</svelte:head>

<div class="flex min-h-dvh flex-col bg-page text-ink">
	<MarketingHeader>
		<a
			href={data.signedIn ? '/home' : '/auth/sign-in'}
			class={cn(CHIP, CHIP_IDLE, 'px-3 py-2 text-sm')}
		>
			{data.signedIn ? m.marketing_go_to_workflows() : m.marketing_sign_in()}
		</a>
	</MarketingHeader>

	<main id="main-content" class={cn(SHELL_WIDE, 'flex flex-1 flex-col gap-10 py-16')}>
		<h1
			class="max-w-4xl text-[clamp(2rem,6vw,3.5rem)] leading-[1.3] font-semibold tracking-tight text-balance wrap-break-word hyphens-auto"
		>
			{m.landing_headline()}
		</h1>

		<p class="max-w-xl text-base leading-relaxed text-pretty text-muted">
			{m.landing_intro()}
		</p>

		<PitchPoints />

		{#if !data.signedIn}
			<AccessForm />
		{/if}
	</main>

	<MarketingFooter />
</div>
